import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const CreateOrgComplianceContext = React.createContext({});
export let createOrgComplianceMachine: any;

const MODULE_NAME = 'machines.createOrgCompliance';

export const useSMCreateOrgComplianceGetContent = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  createOrgComplianceMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(createOrgComplianceMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    createOrgComplianceMachine,
    createOrgComplianceState: state,
    createOrgComplianceSend: send,
  };
};
